export const printingKeys = {
  all: ['printing'] as const,
  lists: () => [...printingKeys.all, 'list'] as const,
  list: (filters?: unknown) => [...printingKeys.lists(), filters] as const,
  details: () => [...printingKeys.all, 'detail'] as const,
  detail: (id: string) => [...printingKeys.details(), id] as const,
  printableBooks: (familyId: string) => [...printingKeys.all, 'printable', familyId] as const,
  order: (orderId: string) => [...printingKeys.all, 'order', orderId] as const,
  orders: (familyId: string) => [...printingKeys.all, 'orders', familyId] as const,
  cost: (bookId: string) => [...printingKeys.all, 'cost', bookId] as const,
  productionCost: (bookId: string) => [...printingKeys.all, 'productionCost', bookId] as const,
  markupPolicy: () => [...printingKeys.all, 'markupPolicy'] as const,
};
